import React, { useState, useCallback, useContext, useEffect } from 'react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Loader, Icon } from '@jutro/components';
import { ServiceManager } from '@jutro/legacy/services';
import _ from 'lodash';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
import { BreakpointTrackerContext } from '@jutro/layout';
import AddressUtil from 'twia-capability-quoteandbind-residential-react/util/AddressUtil';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import AddressDetails from 'twia-capability-quoteandbind-residential-react/components/PropertyDetails/AddressDetails/AddressDetails';
import metadata from './LocationStep.metadata.json5';
// eslint-disable-next-line import/no-relative-packages
import { CpCoverablesService } from '../../../../../capabilities/twia-capability-quoteandbind-cp';
import { BldgLocContext } from '../../../context/BuildingsAndLocationContext';
import BuildingLocationUtil from '../../../util/BuildingLocationUtil';
import messages from './LocationStep.messages';
// eslint-disable-next-line import/no-relative-packages
import TWIAWizardMessagesMessages from '../../../../../modules-react/twia-portals-wizard-components-ui/common/TWIAWizardMessages.messages';

import { Link } from '@jutro/router';

function LocationStep(props) {
    const { id, handleNextClick, handleCancelClick, submissionVM,
        updateWizardData, showStepper } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const [showErrors, setShowErrors] = useState(false);
    const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value');
    const sessionID = submissionVM.sessionUUID.value;
    const { authHeader } = useAuthentication();
    const LocationDTOName = 'edge.capabilities.policyjob.lob.commercialproperty.coverables.dto.LocationDTO';
    const { isComponentValid, onValidate, disregardFieldValidation } = useValidation(id);
    const viewModelService = useContext(ViewModelServiceContext);
    const [locationVM, setLocationVM] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const localeService = ServiceManager.getService('locale-service');
    const defaultCountryCode = localeService.getDefaultCountryCode();
    const translator = useContext(TranslatorContext);
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const EXISTING = "existing";
    const NEW = "new";
    const [locationType, setLocationType] = useState(EXISTING);
    const { refreshData } = useDataRefresh();
    const { commercialProperty } = submissionVM.lobData;
    let existingLocations = commercialProperty.coverables.locations.value;
    const defaultLocationStateCode = viewModelService.productMetadata.get('pc').types
        .getTypelist('State').getCode('TX');

    existingLocations = existingLocations?.slice().sort((a, b) => {
        const aAttribute = a.isPrimary;
        const bAttribute = b.isPrimary;

        return bAttribute - aAttribute;
    });

    const [existingLocationsVM, setExistingLocationsVM] = useState();
    const [chosenExistingLocVM, setChosenExistingLocVM] = useState();
    const [existingSelectedLocation, setexistingSelectedLocation] = useState();
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal';

    const updateNonSpecificLocation = useCallback((locationViewModel) => {
        if (!locationViewModel.locationAdditionalFields_TWIA.isNonSpecificLocation_TWIA.value) {
            // eslint-disable-next-line no-param-reassign
            locationViewModel.locationAdditionalFields_TWIA.isNonSpecificLocation_TWIA.value = false;
            // eslint-disable-next-line no-param-reassign
            locationViewModel.isNonSpecificLocation_TWIA.value = false;
        }
    }, []);

    const createNewLocationVM = useCallback(() => {
        const newlocation = {
            address: {},
            locationAdditionalFields_TWIA: { territoryCode_TWIA: {} },
            displayLocationAddressDTO_TWIA: {},
            isNonSpecificLocation_TWIA: null,
            buildings: []
        };

        const locationViewModel = viewModelService.create(
            newlocation,
            'pc', LocationDTOName,
        );

        if (!locationViewModel.displayLocationAddressDTO_TWIA.state.value) {
            locationViewModel.displayLocationAddressDTO_TWIA.state
                .value = defaultLocationStateCode;
            locationViewModel.displayLocationAddressDTO_TWIA.country
                .value = defaultCountryCode;
        }

        updateNonSpecificLocation(locationViewModel);

        return locationViewModel
    }, [defaultCountryCode, defaultLocationStateCode, updateNonSpecificLocation,
        viewModelService]);

    const createExistingLocationVM = useCallback((location) => {
        const locationViewModel = viewModelService.create(
            location,
            'pc', LocationDTOName,
        );

        if (!locationViewModel.locationAdditionalFields_TWIA?.value) {
            locationViewModel.locationAdditionalFields_TWIA
                .value = { territoryCode_TWIA: { code: locationViewModel.value.territoryCode } };
        }

        updateNonSpecificLocation(locationViewModel);

        return locationViewModel
    }, [updateNonSpecificLocation, viewModelService]);

    useEffect(() => {
        setIsLoading(true);

        let locationViewModel;

        if ((selectedLocation && _.get(selectedLocation, 'isNew')) || !showStepper) {
            setLocationType(NEW);
        }

        if (locationType === NEW) {
            locationViewModel = selectedLocation
                ? createExistingLocationVM(selectedLocation.value)
                : createNewLocationVM();
        } else {
            locationViewModel = selectedLocation
                ? createExistingLocationVM(selectedLocation.value)
                : createExistingLocationVM(existingLocations[0]);
        }

        const existingLocVM = existingLocations?.map(loc =>
            viewModelService.create(loc, 'pc', LocationDTOName));

        setExistingLocationsVM(() => existingLocVM);

        // DE15958
        if (!_.isUndefined(selectedLocation) && !_.isNull(selectedLocation)) {
            const locationIndexNum = _.findIndex(existingLocations, (loc) => loc.publicID === chosenLocation[0]?.publicID?.value);

            setexistingSelectedLocation(() => existingLocVM[locationIndexNum])
        }
        
        if (selectedLocation) {
            setChosenExistingLocVM(() => selectedLocation);
            setLocationVM(selectedLocation);
        } else {
            setChosenExistingLocVM(() => existingLocVM[0]);
            setLocationVM(locationViewModel);
        }

        setIsLoading(false);
    }, []);

    const handleLocationTypeChange = useCallback((value) => {
        setLocationType(() => value);

        let locModel;

        if (value === NEW) {
            locModel = createNewLocationVM()
        } else {
            disregardFieldValidation('AddressDetails');
            locModel = createExistingLocationVM(chosenExistingLocVM.value)
        }

        setLocationVM(locModel);
    }, [chosenExistingLocVM, createExistingLocationVM, createNewLocationVM,
        disregardFieldValidation]);

    const handleExistingLocationChange = useCallback((value) => {
        const location = _.find(existingLocations, (loc) => loc.publicID === value);
        const locModel = createExistingLocationVM(location);
        if (showStepper) {
            locModel.value.buildings = [];
        }
        setChosenExistingLocVM(() => locModel);
        setLocationVM(locModel);
    }, [createExistingLocationVM, existingLocations]);

    const writeValue = useCallback(
        (value, path) => {
            const clonedLocVM = _.clone(locationVM);

            if (_.includes(path, 'isNonSpecificLocation_TWIA')) {
                // eslint-disable-next-line no-secrets/no-secrets
                _.set(clonedLocVM, 'isNonSpecificLocation_TWIA.value', value);
            }

            _.set(clonedLocVM, path, value);
            setLocationVM(() => clonedLocVM);
            refreshData();
        }, [locationVM, refreshData]
    );

    const onNext = useCallback(async () => {
        if (!isComponentValid) {
            setShowErrors(true);

            return;
        }

        // When adding a new building with existing location, we want to make sure construction details are reset to avoid DTO validation error.
        if (!_.isUndefined(selectedBuildingIndex) && locationVM.value.buildings.length > 0 && !locationVM.buildings.children[selectedBuildingIndex].construction_TWIA.aspects.subtreeValid) {
            _.set(locationVM, `buildings.value[${selectedBuildingIndex}].construction_TWIA`, undefined);
        }

        setShowErrors(false);
        setIsLoading(true);

        let location;
        const prevLoc = selectedLocation;

        setSelectedLocation(locationVM);
        submissionVM.selectedLocation = locationVM
        submissionVM.setSelectedLocation = setSelectedLocation
        AddressUtil.fillPrimaryAddressDetails(locationVM.address,
            locationVM.value.displayLocationAddressDTO_TWIA, translator);

        // DE16005
        // eslint-disable-next-line no-secrets/no-secrets
        if (_.get(locationVM, 'locationAdditionalFields_TWIA.eastOfHighway146_TWIA.aspects.visible') === false) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(locationVM, 'locationAdditionalFields_TWIA.eastOfHighway146_TWIA.value', null)
        }

        // accessDescription_TWIA is supposed to unset when accessibleByRoad_TWIA is answered as YES, Othewrise we get an error due to NotSet Edge annotation.
        // eslint-disable-next-line no-secrets/no-secrets
        if (_.get(locationVM, 'locationAdditionalFields_TWIA.accessibleByRoad_TWIA.value') === true) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(locationVM, 'locationAdditionalFields_TWIA.accessDescription_TWIA.value', null)
        }

        if (!locationVM.value.publicID) {
            location = await CpCoverablesService.addCPLocation(
                jobID,
                locationVM.value,
                sessionID,
                authHeader
            )
            locationVM.isNew = true;
        } else {
            location = await CpCoverablesService.updateCPLocation(
                jobID,
                locationVM.value,
                sessionID,
                authHeader
            )
        }

        if (prevLoc && prevLoc.isNew && prevLoc.publicID.value !== locationVM.publicID.value) {
            BuildingLocationUtil.removeLocation(prevLoc, submissionVM,
                authHeader);
        }
        // DE17115
        const newLocation = _.cloneDeep(locationVM.value)

        _.remove(submissionVM.lobData.commercialProperty.coverables.locations.value,
            (currLocation) => currLocation.publicID === location.publicID);
        submissionVM.lobData.commercialProperty.coverables.locations.value.push(location);

        const locationViewModel = viewModelService.create(
            newLocation,
            'pc', LocationDTOName,
        );

        locationViewModel.publicID.value = location.publicID;
        locationViewModel.isPrimary.value = location.isPrimary;
        locationViewModel.territoryCode.value = location.territoryCode;
        locationViewModel.displayName.value = location.displayName
        setSelectedLocation(locationViewModel);
        submissionVM.selectedLocation = locationViewModel
        submissionVM.setSelectedLocation = setSelectedLocation
        updateWizardData(submissionVM);
        setIsLoading(false);
        handleNextClick();
    }, [isComponentValid, selectedBuildingIndex, selectedLocation, 
        setSelectedLocation, locationVM, submissionVM, translator, 
        viewModelService, updateWizardData, handleNextClick, jobID, sessionID, authHeader])

    const updateTerritoryCodeTwia = useCallback(() => {
        const addressVm = locationVM.displayLocationAddressDTO_TWIA;
        const reqVM = viewModelService.create({}, 'pc',
            'org.twia.edge.capabilities.quote.submission.dto.LocationCodesRequestDTO');

        AddressUtil.createRequestData(submissionVM, reqVM,
            addressVm.value, translator);

        if (reqVM.aspects.valid && reqVM.aspects.subtreeValid) {
            setIsLoading(true);
            CustomQuoteService.applyCodes(reqVM.value, authHeader).then(result => {
                if (result && result.territoryCode) {
                    locationVM.locationAdditionalFields_TWIA.territoryCode_TWIA
                        .code.value = result.territoryCode;
                } else {
                    locationVM.locationAdditionalFields_TWIA.territoryCode_TWIA
                        .code.value = null;
                }

                setLocationVM(() => locationVM);
                refreshData();
                setIsLoading(false);
            }).catch(() => {
                locationVM.locationAdditionalFields_TWIA.territoryCode_TWIA.code.value = null;
                setIsLoading(false);
            });
        }
    }, [authHeader, locationVM, refreshData, submissionVM, translator, viewModelService]);

    const updateLocationVM = useCallback((addressVM, isUpdate) => {
        // eslint-disable-next-line no-secrets/no-secrets
        _.set(locationVM, 'displayLocationAddressDTO_TWIA.value', addressVM.value)
        setLocationVM(() => locationVM);
        refreshData();

        if (isUpdate) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(locationVM, 'locationAdditionalFields_TWIA.territoryCode_TWIA.code.value', undefined);
            setLocationVM(() => locationVM);
            refreshData();
            updateTerritoryCodeTwia(addressVM)
        }
    }, [locationVM, refreshData, updateTerritoryCodeTwia]);

    const isMapVisible = useCallback(() =>
        // eslint-disable-next-line no-secrets/no-secrets
        _.get(locationVM, 'locationAdditionalFields_TWIA.eastOfHighway146_TWIA.aspects.visible') === true
        , [locationVM]);

    const getAvailableLocations = useCallback(() =>
        existingLocationsVM.map(loc => ({
            name: loc.value.displayName,
            code: loc.value.publicID,
        })), [existingLocationsVM]);

    const navigateToGoogleMaps = useCallback(() => {
        const url = 'https://maps.google.com/';

        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url, '_blank');
    }, []);

    // DE17232
    const getWarningMessage = useCallback(() =>
    (<div className={wizardStyles.displaydiv}>
        <div className={wizardStyles.divpadding}>
            <Icon icon="gw-warning" size="large" className={wizardStyles.iconColor} />
        </div>
        <div>
            <div>
                {translator(messages.alertTitle, {
                    buildingsCount: <b>{`${locationVM?.buildings.value?.length} Buildings`}</b>,
                })}
            </div>
            {/* <div>
                {translator(messages.changeLocation)}
                <ol>
                   
                    <li>Click <Link onClick={() => { handleCancelClick(locationVM, setSelectedLocation) }}>View Buildings</Link>
                    </li>
                    <li>{translator(messages.selectBuilding)}</li>
                    <li>{translator(messages.expandLocation)}</li>
                </ol>
            </div> */}
        </div>
    </div>), [locationVM, translator]);

    const cancelAddLocation = useCallback(async () => {
        await handleCancelClick(existingSelectedLocation, setSelectedLocation);
    }, [handleCancelClick, existingSelectedLocation, setSelectedLocation]);

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        locationToggle: {
            visible: showStepper,
            value: locationType
        },
        addressDetailsSection: {
            visible: !_.isUndefined(locationVM),
            locationAddressVM: locationVM?.displayLocationAddressDTO_TWIA,
            updateLocationVM,
            showErrors,
            onValidate,
            isRenewal,
            isLocationStep: true,
        },
        existingLocationsList: {
            visible: locationType === EXISTING,
            availableValues: existingLocationsVM ? getAvailableLocations() : [],
            value: chosenExistingLocVM?.value.publicID
        },
        newLocationFields: {
            visible: locationType === NEW
        },
        googleMaps: {
            visible: isMapVisible()
        },
        nextButton: {
            content: !showStepper ? translator(TWIAWizardMessagesMessages.TWIAWizardModalSave)
                : translator(TWIAWizardMessagesMessages.TWIAWizardModalNext)
        },
        wizardActionButtons: {
            justifyContent: !showStepper ? 'right' : 'between'
        },
        locationDetailsTitle: {
            visible: !showStepper
        },
        locationSeparator: {
            visible: showStepper
        },
        locationWarning: {
            visible: !showStepper && locationVM?.buildings.value?.length > 1,
            content: getWarningMessage()
        },
        locationBr: {
            visible: !showStepper && locationVM?.buildings.value?.length > 1,
        }
    }

    const resolvers = {
        resolveClassNameMap: wizardStyles,
        resolveCallbackMap: {
            onNext,
            handleCancelClick: cancelAddLocation,
            handleLocationTypeChange,
            handleExistingLocationChange,
            googleMapsLink: navigateToGoogleMaps
        },
        resolveComponentMap: {
            addressDetailsComponent: AddressDetails
        }
    }

    return (
        <Loader loaded={!isLoading}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={locationVM}
                overrideProps={overrideProps}
                onValueChange={writeValue}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                showErrors={showErrors}
            />
        </Loader>
    )
}

export default LocationStep